import { useMemo, useEffect } from 'react';
import { useTable, useFlexLayout, useSortBy } from 'react-table';
import { GroupTable } from '@/components//presentation/GroupTable';
import { cx } from '@trinity/chat-components';
import { DnDUploadContainer } from './DnDUploadContainer';
import { useFilesTableColumns } from './hooks/useFilesTableColumns';
import type { IFilesTable } from './interfaces';
import styles from './style/Files.Table.module.css';

type Props = {
  classes?: {
    root?: string;
  };
  canUpload: boolean;
  items: IFilesTable.Item[];
  onUpload?: (files: File[]) => unknown;
  pagination: {
    pageIndex: number;
    pageSize: number;
    sortBy: IFilesTable.SortingRule[];
    updateSortBy: (sortBy: IFilesTable.SortingRule) => unknown;
  };
};

export const FilesTableList = ({ canUpload, items, pagination: { pageIndex, pageSize, sortBy, updateSortBy }, onUpload, classes = {} }: Props) => {
  const columns = useFilesTableColumns();

  const tableInstance = useTable(
    {
      columns,
      data: items,
      initialState: {
        pageIndex,
        pageSize,
        sortBy: sortBy.map(sb => ({ id: sb.field, desc: sb.desc })),
      },
      manualSortBy: true,
    },
    useFlexLayout,
    useSortBy,
  );

  useEffect(() => {
    // @ts-expect-error We never setup react-table types properly
    const sort = tableInstance.state.sortBy[0] as IFilesTable.SortingRule;
    updateSortBy({
      // @ts-expect-error We never setup react-table types properly
      field: sort.id as IFilesTable.SortingRule['field'],
      desc: sort.desc,
    });
  }, [tableInstance.state.sortBy, updateSortBy]);

  const tableClasses = useMemo(() => ({
    body: cx(styles.body, classes.root),
    td: styles.td,
  }), [classes.root]);

  return (
    <DnDUploadContainer
      canUpload={canUpload}
      onUpload={onUpload}>
      <GroupTable
        classes={tableClasses}
        instance={tableInstance} />
    </DnDUploadContainer>
  );
};

export default FilesTableList;